<template>
  <div class="p-search container">
    <div class="m-searchbar">
      <div class="m-searchbar__input-wrapper">
        <label for="search_keyword">搜尋</label>
        <input
          id="search_keyword"
          v-model="query.q"
          v-focus
          type="text"
          placeholder="請輸入關鍵字"
          @keyup.enter="searching"
        >
      </div>
      <button class="m-searchbar__btn" title="使用關鍵字搜尋" aria-label="使用關鍵字搜尋" @click="searching">
        <title>使用關鍵字搜尋</title>
        <svg width="24" height="24">
          <path d="M23.635 21.86l-5.916-5.94a9.46 9.46 0 002.354-6.23c0-5.343-4.502-9.69-10.036-9.69S0 4.347 0 9.69c0 5.343 4.503 9.69 10.037 9.69 2.077 0 4.057-.605 5.75-1.753l5.961 5.985c.25.25.585.388.944.388.34 0 .662-.125.907-.353.52-.483.537-1.284.036-1.787zM10.037 2.528c4.09 0 7.418 3.213 7.418 7.162 0 3.95-3.328 7.162-7.418 7.162S2.618 13.64 2.618 9.69c0-3.95 3.328-7.162 7.419-7.162z" fill="#fff" fill-rule="nonzero" />
        </svg>
      </button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  directives: {
    focus: {
      inserted(el) {
        el.focus()
      }
    }
  },
  asyncData({ route, error }) {
    if (route.query && route.query.q) {
      error({ statusCode: 404 })
    }
  },
  data() {
    return {
      pageTitle: '新聞搜尋 | CTWANT',
      query: {
        q: '',
        category: '',
        page: 1
      }
    }
  },
  head() {
    const hostAndNeedBackslashPath = this.HOST + (this.$route.path.substr(this.$route.path.length - 1) === '/' ? this.$route.path : `${this.$route.path}/`)

    const BreadcrumbList = {
      '@context': 'http://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: [
        {
          '@type': 'ListItem',
          position: 1,
          item: {
            '@id': this.HOST,
            name: 'CTWANT'
          }
        },
        {
          '@type': 'ListItem',
          position: 2,
          item: {
            '@id': hostAndNeedBackslashPath,
            name: this.pageTitle
          }
        }
      ]
    }

    return {
      title: this.pageTitle,
      meta: [
        { hid: 'ogUrl', property: 'og:url', content: hostAndNeedBackslashPath },
        { hid: 'ogTitle', property: 'og:title', content: this.pageTitle }
      ],
      link: [
        { hid: 'alternate', rel: 'alternate', hreflang: 'zh-Hant', href: hostAndNeedBackslashPath },
        { hid: 'canonical', rel: 'canonical', href: hostAndNeedBackslashPath }
      ],
      __dangerouslyDisableSanitizers: ['script'],
      script: [
        { innerHTML: JSON.stringify(BreadcrumbList), type: 'application/ld+json' }
      ]
    }
  },
  computed: {
    ...mapGetters([
      'HOST',
      'WIDTH_PAD',
      'screenWidth'
    ])
  },
  methods: {
    searching() {
      if (this.query.q === '') {
        this.$notyf.error('請輸入搜尋關鍵字')
        return
      }
      if (this.query.q.length > 20) {
        this.$notyf.error('搜尋關鍵字請少於 20 個字')
        return
      }
      this.query.q = this.query.q.trim()
      const obj = {
        path: `/search/${this.query.q}/`
      }
      this.$router.push(obj)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~/assets/scss/pages/_search';
</style>
